export type Preconnect = {
  href: string;
  id?: string | null;
}

export interface Preload {
  href: string;
  as: string;
  id?: string | null; // If undefined, uses "href". If null, not added at all.
  fetchpriority?: 'high' | 'low' | 'auto'; // See: https://web.dev/articles/fetch-priority
  imagesrcset?: string;
  imagesizes?: string;
  crossorigin?: 'anonymous' | 'use-credentials' | '';
}

export function asPreconnect(preconnect: Preconnect) {
  return {
    rel: 'preconnect',
    ...preconnect,
    id: preconnect.id ?? (preconnect.id !== null ? preconnect.href : undefined),
  };
}

export function asPreload(preload: Preload) {
  return {
    rel: 'preload',
    ...preload,
    id: preload.id ?? (preload.id !== null ? preload.href : undefined),
  };
}
